import type { ElementFolder } from '../../types'

interface ElementSidebarProps {
  folderList: ElementFolder[]
  activeFolder: string
  onFolderSelect: (folderName: string) => void
}

const ELEMENT_SYSTEM_FOLDER_ICONS: Record<string, string> = {
  INBOX: '◈',
  Sent: '↑',
  Drafts: '◎',
  Spam: '⊘',
  Trash: '⊗'
}

export function ElementSidebar({
  folderList,
  activeFolder,
  onFolderSelect
}: ElementSidebarProps) {
  const systemFolders = folderList.filter(folder => folder.system === 1)
  const customFolders = folderList.filter(folder => folder.system === 0)

  return (
    <aside className="element-sidebar">
      <div className="element-sidebar-brand">
        <span className="element-brand-name">Element</span>
        <span className="element-brand-subtitle">Mail</span>
      </div>

      <button
        className="element-compose-button"
        onClick={() => {
          const composeEvent = new CustomEvent('element:open-compose')
          window.dispatchEvent(composeEvent)
        }}
      >
        + Compose
      </button>

      <nav className="element-folder-navigation">
        <div className="element-folder-group">
          {systemFolders.map(systemFolder => (
            <button
              key={systemFolder.id}
              className={`element-folder-item ${activeFolder === systemFolder.name ? 'element-folder-item--active' : ''}`}
              onClick={() => onFolderSelect(systemFolder.name)}
            >
              <span className="element-folder-icon">
                {ELEMENT_SYSTEM_FOLDER_ICONS[systemFolder.name] || '◉'}
              </span>
              <span className="element-folder-label">{systemFolder.name}</span>
            </button>
          ))}
        </div>

        {customFolders.length > 0 && (
          <div className="element-folder-group element-folder-group--custom">
            <span className="element-folder-group-label">Folders</span>
            {customFolders.map(customFolder => (
              <button
                key={customFolder.id}
                className={`element-folder-item ${activeFolder === customFolder.name ? 'element-folder-item--active' : ''}`}
                onClick={() => onFolderSelect(customFolder.name)}
              >
                <span className="element-folder-icon">◉</span>
                <span className="element-folder-label">{customFolder.name}</span>
              </button>
            ))}
          </div>
        )}
      </nav>
    </aside>
  )
}
